export default{sideNavigation:"w_Cj",list:"w_Ck"};
